import { useEffect } from "react";

/**
 * Hook to perform actions when the document becomes visible.
 * @param callback Function to call when the document becomes visible.
 * @param deps Dependency array for the useEffect hook.
 */
const useVisibilityChange = (callback: () => void) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isDocumentVisible = !document.hidden;
      if (isDocumentVisible) {
        callback();
      }
    };

    if (typeof window !== "undefined" && typeof document !== "undefined") {
      // Add event listener for visibility change
      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup function to remove the event listener
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    }
  }, [callback]); // Ensure callback and dependencies are correctly listed
};

export default useVisibilityChange;
